<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form-row @keyup.enter="load">
          <b-col lg="5" sm="12" class="text-left">
            <lg-form-input
              v-model="form.descricao"
              label="Descricão:"
              description=""
            />
          </b-col>
          <b-col lg="3" sm="12" class="text-left">
            <lg-form-const-select
              label="Situação:"
              v-model="form.situacao"
              :options="form.optionsFilterSituacao"
              @change="load"
            />
          </b-col>

          <b-col cols="4" class="text-right">
            <b-button
            id="localizar"
              class="mr-2 my-2"
              size="sm"
              pill
              style="height: 20px"
              variant="primary"
              @click="load"
            >
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
                <b-tooltip target="localizar" title="Localizar"></b-tooltip>

              </div>
            </b-button>
            <b-button
              style="height: 20px"
              class="ml-3 mr-2 my-2"
              size="sm"
              pill
              @click="clearForm"
              id="limpar"
              ><div class="btn-size-alinhamento">
                <b-icon icon="eraser" />
              </div>
              
              <b-tooltip target="limpar" title="Limpar"></b-tooltip>
            </b-button>

            <b-button
              v-if="temPrivilegioCadastro()"
              class="ml-3 mr-2 my-2"
              size="sm"
              style="height: 20px"
              pill
              variant="primary"
              @click="showManuaisModal"
              id="novo"
            >
              <div class="btn-size-alinhamento">
                <b-icon scale="1" icon="plus" />
              </div>
              <b-tooltip target="novo" title="Adicionar novo..."></b-tooltip>

            </b-button>
          </b-col>
        </b-form-row>
        <b-table
          responsive
          class="mt-2"
          small
          :busy="this.busy"
          :items="this.records"
          :fields="this.tableFields"
          :hover="true"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template v-slot:cell(editar)="row">
            <b-button :disabled="!temPrivilegioEdicao()"
              :id="row.index + 'edit-button'"
              class="my-2"
              size="sm"
              pill
              variant="primary"
              @click="editarManuais(row.item)"
            >
              <b-icon icon="pencil-square" />
              <b-tooltip
                :target="row.index + 'edit-button'"
                title="Editar..."
              ></b-tooltip>
            </b-button>
          </template>

          <template v-slot:cell(documentos)="row">
            <b-button
              :id="row.index + 'docs-button'"
              class="my-2"
              size="sm"
              pill
              variant="info"
              @click="abrirDocumentos(row.item)"
            >
              <b-icon icon="file-earmark-pdf" />
              <b-tooltip
                :target="row.index + 'docs-button'"
                title="Visualizar Documentos"
              ></b-tooltip>
            </b-button>
          </template>

          <template v-slot:cell(detalhar)="row">
            <b-button
              :id="row.index + 'detalhar-button'"
              class="my-2"
              size="sm"
              pill
              variant="primary"
              @click="detalharManuais(row.item)"
            >
              <b-icon icon="eye" />
              <b-tooltip
                :target="row.index + 'detalhar-button'"
                title="Detalhar..."
              ></b-tooltip>
            </b-button>
          </template>

          <template v-slot:cell(situacao)="row">
            <div :id="row.index + 'switch'">
              <b-form-checkbox
              :disabled="!temPrivilegioInativacao()"
                v-model="row.item.situacao"
                @change="alteraSituacao(row.item)"
                name="check-button"
                switch
                size="lg"
                :value="1"
                :unchecked-value="0"
              />
              <b-tooltip
                :target="row.index + 'switch'"
                title="Ativar/Desativar..."
              ></b-tooltip>
            </div>
          </template>
        </b-table>

        <b-row style="margin-top: 12px" v-if="records && records.length > 0">
          <b-col
            cols="6"
            style="display: flex; align-items: center; font-size: 12px"
          >
            <b-col
              cols="6"
              style="display: flex; align-items: center; font-size: 12px"
              >Página {{ page }} de {{ totalPage }} -
              {{ total }} registros</b-col
            >
            <b-col
              cols="6"
              style="display: flex; align-items: center; font-size: 12px"
              >Mostrando:&nbsp;
              <b-form-select
                size="sm"
                v-model="perPage"
                @change="load"
                :options="perPageOptions"
              >
              </b-form-select>
            </b-col>
          </b-col>
          <b-col cols="6">
            <div class="d-flex justify-content-end align-items-end">
              <b-pagination
                style="margin-bottom: 10px; margin-top: 10px"
                v-model="page"
                :per-page="perPage"
                :total-rows="total"
                align="right"
              ></b-pagination>
            </div>
          </b-col>
        </b-row>
        <manuais-roteiros-atos-form
          v-if="showModalManuaisForm"
          @close="cancelar"
          @save="load"
          :prefix="title + ' > '"
          :id="currentManuaisId"
          :disabled="disabled"
        />
      </b-card>
    </b-card-body>

    <!-- Modal Lista de Documentos -->
    <b-modal
      v-model="showDocumentosModal"
      size="md"
      hide-footer
      title="Selecione um Documento"
    >
      <b-table
        responsive
        small
        :items="documentosList"
        :fields="documentosFields"
        :hover="true"
        class="table-hover link-style"
        @row-clicked="visualizarDocumento"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </b-modal>

    <!-- Modal Visualizador de PDF -->
    <b-modal
      v-model="showPdfViewer"
      size="xl"
      hide-footer
      title="Visualizar Documento"
      @hidden="closePdfViewer"
    >
      <div style="height: 75vh;">
        <iframe
          v-if="pdfBlobUrl"
          :src="pdfBlobUrl"
          width="100%"
          height="100%"
          style="border: none;"
        ></iframe>
      </div>
    </b-modal>

    <!-- Modal Loading Documento -->
    <b-modal
      v-model="loadingDocumento"
      size="sm"
      hide-footer
      hide-header
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="text-center py-4">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
        <p class="mt-3 mb-0">Carregando documento...</p>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import { downloadArquivo } from "@/components/generators/downloads/index.js"
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { ListResourceMixin } from "@/core/mixins/resource"
import ManuaisRoteirosAtosForm from "./ManuaisRoteirosAtosForm.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import ManuaisRoteirosAtosService from "@/core/api/ManuaisRoteirosAtosService"
import ItemRepositorioDocumentoService from "@/core/api/ItemRepositorioDocumentoService"
import DownloadArquivoUtil from "@/core/utils/DownloadArquivoUtil"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
  name: "ManuaisRoteirosAtosList",
  components: {
    ManuaisRoteirosAtosForm,
    LgFormInput,
    LgFormConstSelect,
  },
  data() {
    return {
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      filtro: "",
      title: "Manuais, Roteiros e Atos",
      currentManuaisId: null,
      showModalManuaisForm: false,
      disabled: {
        type: Boolean,
        default: false,
      },
      showModal: true,
      showDocumentosModal: false,
      showPdfViewer: false,
      pdfBlobUrl: null,
      documentosList: [],
      loadingDocumento: false,
      documentosFields: [
        { key: "nomeDocumento", label: "Nome do Documento" },
      ],
      form: {
        descricao: "",
        situacao: 1,
        optionsFilterSituacao: [
          { key: "filterSituacao", text: "Todos", value: null },
          { key: "filterSituacao", text: "Ativo", value: 1 },
          { key: "filterSituacao", text: "Inativo", value: 0 },
        ],
      },
    }
  },
  mixins: [ListResourceMixin, ConfirmMixin],

  beforeMount() {
    this.$ManuaisRoteirosAtosService = new ManuaisRoteirosAtosService()
    this.$ItemRepositorioDocumentoService = new ItemRepositorioDocumentoService()
  },

  mounted() {
    this.load()
  },

  watch: {
    page() {
      this.load()
    },
  },

  computed: {
    tableFields() {
      return [
        {
          key: "descricao",
          label: "Descricao",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "documentos",
          label: "",
          tdClass: "w-1 pl-3",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "detalhar",
          label: "",
          tdClass: "w-1 pl-3",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "editar",
          label: "",
          tdClass: "w-1 pl-3",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
        {
          key: "situacao",
          label: "",
          tdClass: "w-1 pl-3",
          thStyle: "font-size: 16px; font-weight: 400;",
          tdStyle: "font-size: 13px",
        },
      ]
    },
  },

  methods: {
    temPrivilegioCadastro() {
      return verificaPrivilegio(PrivilegiosEnum.MANUAIS_ROTEIROS_ATOS_INCLUIR);

    },
    temPrivilegioEdicao() {
      return verificaPrivilegio(PrivilegiosEnum.MANUAIS_ROTEIROS_ATOS_EDITAR);

    },
    temPrivilegioInativacao() {
      return verificaPrivilegio(PrivilegiosEnum.MANUAIS_ROTEIROS_ATOS_ATIVAR_INATIVAR);

    },

    async downloadArchieves(este) {
      this.$download = new ResourceService(
        `/api/itemmanuaisroteirosatos/todosdocporid`
      )
      let resposta = await this.$download.findById(este.id)
      if (resposta.data.length > 0) {
        resposta.data.map(arquivo => downloadArquivo(arquivo))
        this.$notify({
          type: "success",
          message: `download concluído`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Registro sem documentos anexados`,
        })
      }
    },

    async load() {
      this.busy = true
      await this.$ManuaisRoteirosAtosService
        .findAll({
          size: this.perPage,
          page: this.page,
          descricao: this.form.descricao,
          situacao: this.form.situacao,
        })
        .then(response => {
          this.records = response.data.content
          this.total = response.data.totalElements
          this.totalPage = response.data.totalPages
        })
        .finally(() => {
          this.busy = false
        })
    },

    clearForm() {
      this.form.descricao = ""
      this.form.situacao = 1
      this.load()
    },

    editarManuais(manuais) {
      this.currentManuaisId = manuais.id
      this.showModalManuaisForm = true
      this.disabled = false
    },

    showManuaisModal() {
      this.currentManuaisId = null
      this.showModalManuaisForm = true
      this.disabled = false
    },

    detalharManuais(manuais) {
      this.currentManuaisId = manuais.id
      this.showModalManuaisForm = true
      this.disabled = true
    },

    cancelar() {
      this.currentManuaisId = null
      this.showModalManuaisForm = false
      this.load()
    },

    async alteraSituacao(item) {
      let response

      if (item.situacao == 1) {
        response = await this.$confirm(
          `Deseja ativar o registro?`,
          item.descricao.toUpperCase()
        )
      }
      if (item.situacao == 0) {
        response = await this.$confirm(
          `Deseja desativar o registro?`,
          item.descricao.toUpperCase()
        )
      }

      if (response === true) {
        this.confirmarAlteracaoSituacao(item)
      } else {
        item.situacao = item.situacao == 1 ? 0 : 1
      }
    },

    async confirmarAlteracaoSituacao(item) {
      const { status } = await this.$ManuaisRoteirosAtosService.alteraSituacao(
        item
      )
      if (status == 200) {
        this.$notify({
          type: "success",
          message: `Registro ${
            item.situacao ? "Ativado" : "Desativado"
          } com sucesso!`,
        })
      } else {
        this.$notify({
          type: "danger",
          message: `Erro ao ${
            item.situacao ? "Ativar" : "Desativar"
          } o registro!`,
        })
      }
    },

    async abrirDocumentos(item) {
      this.$download = new ResourceService(
        `/api/itemmanuaisroteirosatos/todosdocporid`
      )
      let resposta = await this.$download.findById(item.id)

      if (resposta.data.length === 0) {
        this.$notify({
          type: "danger",
          message: "Registro sem documentos anexados",
        })
        return
      }

      if (resposta.data.length === 1) {
        const doc = resposta.data[0]
        await this.carregarEVisualizarDocumento(doc)
      } else {
        this.documentosList = resposta.data
        this.showDocumentosModal = true
      }
    },

    async visualizarDocumento(item) {
      this.showDocumentosModal = false
      await this.carregarEVisualizarDocumento(item)
    },

    async carregarEVisualizarDocumento(doc) {
      this.loadingDocumento = true
      try {
        const response = await this.$ItemRepositorioDocumentoService.findById(doc.id)
        const arquivo = response.data.arquivoBase64
        const nome = response.data.nomeDocumento

        if (nome && nome.toLowerCase().endsWith('.pdf')) {
          this.openPdfViewer(arquivo)
        } else {
          DownloadArquivoUtil(arquivo, nome)
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Erro ao carregar o documento",
        })
      } finally {
        this.loadingDocumento = false
      }
    },

    openPdfViewer(base64Data) {
      const binaryString = window.atob(base64Data)
      const len = binaryString.length
      const bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      const blob = new Blob([bytes], { type: 'application/pdf' })
      this.pdfBlobUrl = URL.createObjectURL(blob)
      this.showPdfViewer = true
    },

    closePdfViewer() {
      if (this.pdfBlobUrl) {
        URL.revokeObjectURL(this.pdfBlobUrl)
        this.pdfBlobUrl = null
      }
      this.showPdfViewer = false
    },
  },
}
</script>

<style>
.link-style td {
  color: #0a2c4e !important;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
}
</style>
